import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=80225d18&scoped=true&"
import script from "./AssetsList.vue?vue&type=script&lang=js&"
export * from "./AssetsList.vue?vue&type=script&lang=js&"
import style0 from "./AssetsList.vue?vue&type=style&index=0&id=80225d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80225d18",
  null
  
)

export default component.exports